export { default } from 'DecibelMeter'



// WEBPACK FOOTER //
// ./src/index.js